<template>
  <el-dialog class="person-select-dialog" :close-on-click-modal="false" title="入职申请" :visible.sync="isShowDialog" width="720px" top="15vh" center>
    <el-form ref="ruleForm" :model="form" :rules="userRules" label-width="90px">
      <el-row>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <el-form-item label="姓名：" prop="RealName" :rules="[{ required: true, message: '姓名不能为空' }]">
            <el-input style="width: 240px" clearable v-model.trim="form.RealName" placeholder="请输入姓名" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <el-form-item label="所属部门：" prop="OrgId" :rules="[{ required: true, message: '所属部门不能为空' }]">
            <el-select style="width: 240px" filterable clearable v-model="form.OrgId" placeholder="请选择所属部门">
              <el-option v-for="item in orgListFilter" :key="item.ID" :label="item.Title" :value="item.ID" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <el-form-item label="任职岗位：" prop="JobRankId" :rules="[{ required: true, message: '岗位不能为空' }]">
            <el-select style="width: 240px" clearable v-model="form.JobRankId" placeholder="请选择岗位">
              <el-option v-for="item in jobRankTypeArr" :key="item.ID" :label="item.Title" :value="item.ID" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <el-form-item label="联系方式：" prop="Tel" :rules="[{ required: true, validator: validateTelPhone }]">
            <el-input style="width: 240px" v-model.trim="form.Tel" :clearable="type == 'add'" :disabled="type == 'edit'" @blur="isRepeat(form.Tel)" placeholder="请输入手机号码" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <el-form-item label="电子邮箱：" prop="Email" :rules="[{ required: true, validator: validateEmail }]">
            <el-input style="width: 240px" clearable v-model.trim="form.Email" placeholder="请输入电子邮箱" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <el-form-item label="学历：" prop="Edu" :rules="[{ required: true, message: '学历不能为空' }]">
            <el-select style="width: 240px" clearable v-model="form.Edu" placeholder="请选择学历">
              <el-option v-for="item in educationArr" :key="item" :label="item" :value="item" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <el-form-item label="入职时间：" prop="JoinDate" :rules="[{ required: true, message: '入职时间不能为空' }]">
            <el-date-picker style="width: 240px" clearable v-model="form.JoinDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择入职时间" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer-box">
      <el-button size="small" @click="$emit('update:isShow', false)">取 消</el-button>
      <el-button size="small" type="primary" :load="loading" @click="submitEvent">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { getOrgPage, JobRankQuery, FindDepartmentOrg, IsRepeat, submitEmpJoin } from '@/http/api';
const validateTelPhone = (rule, value, callback) => {
  const reg = /^[1][3-9][0-9]{9}$/;
  if (value == '' || value == undefined || value == null) {
    callback();
  } else {
    if (!reg.test(value) && value != '') {
      callback(new Error('请输入正确的手机号码'));
    } else {
      callback();
    }
  }
};
const validateEmail = (rule, value, callback) => {
  const reg = /^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+$/;
  if (value == '' || value == undefined || value == null) {
    callback();
  } else {
    if (!reg.test(value)) {
      callback(new Error('请输入正确的邮箱地址'));
    } else {
      callback();
    }
  }
};
let oldForm = '';
export default {
  props: ['isShow'],
  data() {
    return {
      orgListFilter: [],
      jobRankTypeArr: [],
      jobRankList: [],
      educationArr: ['博士', '硕士', '本科', '大专', '高中', '中专/中技', '初中及以下'],
      checked: false,
      validateTelPhone,
      validateEmail,
      form: {
        Tel: '',
        RealName: '',
        Email: '',
        JobRankId: '',
        OrgId: '',
        Edu: '',
        JoinDate: '',
      },
      loading: false,
    };
  },
  created() {
    oldForm = JSON.stringify(this.form);
  },
  watch: {
    isShow(val) {
      if (val) {
        this.form = JSON.parse(oldForm);
        this.getOrgList();
        this.getJobRankList();
        this.$nextTick((_) => this.$refs.ruleForm.clearValidate());
      }
    },
    'form.OrgId': {
      handler(val) {
        this.jobRankQuery(val);
      },
    },
  },
  computed: {
    isShowDialog: {
      get() {
        return this.isShow;
      },
      set(v) {
        this.$emit('update:isShow', false);
      },
    },
  },
  methods: {
    // 获取组织架构
    getOrgList() {
      getOrgPage().then((res) => {
        this.orgListFilter = res.filter((item) => item.Title);
      });
    },
    // 获取所有岗位
    getJobRankList() {
      JobRankQuery().then((res) => {
        this.jobRankList = res;
      });
    },
    // 根据部门获取岗位列表
    jobRankQuery(orgId) {
      if (orgId) {
        FindDepartmentOrg(orgId).then((res) => {
          let sql = '1=1';
          if (res) sql += ' and ParentID=' + res.ID;
          JobRankQuery(sql).then((res) => {
            this.jobRankTypeArr = res;
          });
        });
      } else {
        this.jobRankTypeArr = [...this.jobRankList];
      }
    },
    //手机号验重
    isRepeat(tel) {
      if (this.type === 'add') IsRepeat(tel);
    },
    submitEvent() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          submitEmpJoin(this.form)
            .then((res) => {
              if (res.Code) {
                this.$message.success(res.Message);
                this.$emit('update:isShow', false);
              } else {
                this.$message.error(res.Message);
              }
            })
            .finally((_) => (this.loading = false));
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.person-select-dialog {
  :deep(.el-dialog__body) {
    padding: 16px 24px 0px 24px;
  }
  :deep(.el-cascader__search-input) {
    background: #f5f9fa;
  }

  :deep(.el-select__tags) {
    flex-wrap: nowrap;
    overflow: hidden;
  }
  :deep(.el-cascader__tags) {
    flex-wrap: nowrap;
    overflow: hidden;
  }

  :deep(.el-row) {
    display: flex;
    flex-wrap: wrap;
  }

  .dialog-footer-box {
    display: flex;
    justify-content: center;
    :deep(.el-button) {
      width: 120px;
      height: 36px;
      & + .el-button {
        margin-left: 16px;
      }
    }
  }
}
</style>
